import { render, staticRenderFns } from "./Enterprise_forget.vue?vue&type=template&id=6b27bc6f&scoped=true&"
import script from "./Enterprise_forget.vue?vue&type=script&lang=js&"
export * from "./Enterprise_forget.vue?vue&type=script&lang=js&"
import style0 from "./Enterprise_forget.vue?vue&type=style&index=0&id=6b27bc6f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b27bc6f",
  null
  
)

export default component.exports